module.exports = __webpack_public_path__ + "img/552-42dfb3.png";